import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

class ScrollProgressBar extends Component {
  constructor(props) {
    super(props);
    this.barRef = null;
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (!this.barRef) return;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const docHeight = document.body.scrollHeight - window.innerHeight;
    const progress = docHeight > 0 ? scrollTop / docHeight : 0;
    this.barRef.style.width = `${progress * 100}%`;
  }

  render() {
    const { colorPrimary } = this.context.theme;
    return (
      <div className="scroll-progress-track">
        <div
          className="scroll-progress-bar"
          ref={(el) => { this.barRef = el; }}
          style={{ background: colorPrimary }}
        />
      </div>
    );
  }
}

ScrollProgressBar.contextTypes = {
  theme: PropTypes.any,
};

export default ScrollProgressBar;



// WEBPACK FOOTER //
// ./src/components/ScrollProgressBar/ScrollProgressBar.js